/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgNotifications = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.35 2.861a3.681 3.681 0 00-1.42-.614l.196-.98a4.682 4.682 0 013.531 6.057l-.95-.313a3.682 3.682 0 00-1.357-4.15z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.17 1.63l.88-.028 4.626 8.01-.465.75-5.246-.339-.302.174L8.31 13.05l-.183.683-1.732 1-.683-.183-1.647-2.853-.65.375-.683-.183-1.625-2.814.183-.683 3.55-2.05L7.17 1.63zM6.163 9.331L5.038 7.383 2.223 9.008l1.125 1.948 2.815-1.625zM4.93 11.197l1.397 2.42.866-.5-1.397-2.42-.866.5zm6.412-1.894l-4.198-.27L5.788 6.68l1.864-3.77 3.69 6.392z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.763 3.67a2.678 2.678 0 00-1.007-.437l-.202.979a1.678 1.678 0 011.271 2.116l.96.281a2.678 2.678 0 00-1.022-2.938z"
}));

export default SvgNotifications;